module.exports = __webpack_public_path__ + "static/media/phone.89d34723.svg";